import React from "react";
import PropTypes from "prop-types";
import { Image } from "./media";

function SmallSpinner({ center }) {
  if (center) {
    return (
      <div className="center-container mt-2">
        <div className="spinner-border text-warning" role="status">
          <span className="sr-only">Loading...</span>
        </div>
      </div>
    );
  }
  return (
    <div className="spinner-border text-warning" role="status">
      <span className="sr-only">Loading...</span>
    </div>
  );
}
SmallSpinner.propTypes = {
  center: PropTypes.bool.isRequired,
};
SmallSpinner.defaultProps = {
  center: false,
};

function LoaderDots() {
  return (
    <div className="loader-dots-container">
      <span className="loader-dots"></span>
    </div>
  );
}

function Empty({ message }) {
  let emptyMessage;

  if (message) {
    emptyMessage = <span className="empty-message">{message}</span>;
  }
  return (
    <div className="empty-message-container">
      <Image src="svg-icon/components.svg" className="empty-message-icon" />
      {emptyMessage}
    </div>
  );
}
Empty.propTypes = {
  message: PropTypes.string,
};

export { SmallSpinner, Empty, LoaderDots };
